<template>
  <b-modal
    id="create-site-modal"
    title="Site Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Create Site</h2>
    </template>
    <validation-observer ref="siteCreateFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="name">
          <template #label>
            Site Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="name"
            v-model="name"
            v-restrict="regex"
            placeholder="Name"
            required
          />
        </b-form-group>

        <b-form-group label-for="total_staff">
          <template #label>
            Total Staff
          </template>
          <b-form-input
            id="total_staff"
            v-model="total_staff"
            placeholder="Staff"
            type="number"
            
          />
        </b-form-group>

        <b-form-group label-for="trained_staff">
          <template #label>
            Trained Staff 
          </template>
          <b-form-input
            id="trained_staff"
            v-model="trained_staff"
            placeholder="Trained Staff"
            type="number"
            
          />
        </b-form-group>

        <b-form-group label-for="postcode">
          <template #label>
            PostCode 
          </template>
          <b-form-input
            id="postcode"
            v-model="postcode"
            placeholder="PostCode"
            type="number"
            
          />
        </b-form-group>
        
        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  data() {
    return {
      required,
      name: "",
      regex: /^[a-zA-Z ]*$/,
      total_staff: "",
      trained_staff: "",
      postcode:"",
    };
  },
  methods: {
    ...mapActions({
      createSite: "appData/createSite",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("name", this.name);
        formData.append("total_staff", this.total_staff);
        formData.append("trained_staff", this.trained_staff);
        formData.append("postcode", this.postcode);
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.createSite(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Site Created Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-site-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Site name is required.",
              variant: "danger",
              icon: "BellIcon",
            },
          },
          {
            position: "top-right",
          }
        );
      }
    },


    reset() {
      this.name = "";
      this.total_staff = "";
      this.trained_staff = "";
      this.postcode = null;
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style></style>
